


















































































import Vue from 'vue'
import { Dictionary } from 'vue-router/types/router'
import { ApiService } from '../services/api'
import Register from '@/modules/partners/components/Register.vue'
import Login from '@/modules/core/components/Login.vue'
import { mapGetters, mapState } from 'vuex';
import {User} from "@/modules/core/models"
import {UserService} from "@/modules/partners/services/user.service"

ApiService.init(process.env.VUE_APP_API_BACKEND_URL);

export default Vue.extend({
  name: 'App',
  components: {
    Register,
    Login
  },
  data: () => ({
    register_dialog: false,
    login_dialog: false,
    item: 1,
  }),
  computed: {
    _isMenuVisible: {
      get () : boolean {
        return this.loggedIn && this.$vuetify.breakpoint.mdAndUp;
      }
    },
    _isMenuPhoneVisible: {
      get () : boolean {
        return this.loggedIn //&& this.$store.state.showBottonNavigation;
      }
    },
    menu_items: {
      get (): Array<Dictionary<any>> {
        return this.$store.state.menus.filter((menu:any) => {
            let condition: boolean = menu['active'] == true;
            if ("auth" in menu) {
                condition = condition && menu['auth'] == this.loggedIn;
            }
            return condition;
        })
      }
    },
    ...mapState(["loginUser"]),
    ...mapGetters('auth', [
          'loggedIn',
          'authenticating',
          'authenticationError',
          'authenticationErrorCode'
      ]),
    user_initials: {
        get (): string {
            const user = this.$store.state.loginUser;
            return `${user.name[0]}${user.surname[0]}`
        }
    },
    isError: {
        get (): boolean {
            return this.$store.getters['snackbar/isShow']
        },

        set(newValue:boolean): void {
            this.$store.commit("snackbar/changeShow", newValue)
        }
    },
    errorMessage: {
        get (): string {
            return this.$store.getters['snackbar/message']
        }
    }
  },
  methods: {
    logout () {
        this.$store.dispatch("auth/logout") //UserAuthService.logout()
    }
  },
  async mounted () {

    if (this.loggedIn) {
      ApiService.setHeaders();
      ApiService.mount401Interceptor();
      let user:User = await UserService.get_current_user();
      this.$store.commit("setLoginUser",user);
      //await this.$store.dispatch('auth/userLogIn');
    }
  }

})
